module.exports = __webpack_public_path__ + "img/集团架构.8c657826.png";